/**
 * Surprav AJAX Cart Helpers
 * Wraps Shopify AJAX Cart API for use in theme components.
 */

const CART_ROUTES = {
  add: '/cart/add.js',
  change: '/cart/change.js',
  update: '/cart/update.js',
  clear: '/cart/clear.js',
  get: '/cart.js'
};

async function fetchCart() {
  const response = await fetch(CART_ROUTES.get);
  return response.json();
}

async function addToCart(variantId, quantity = 1, properties = {}) {
  const body = JSON.stringify({
    id: variantId,
    quantity,
    properties,
    sections: ['cart-drawer', 'cart-icon-bubble'],
    sections_url: window.location.pathname
  });

  const response = await fetch(CART_ROUTES.add, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.description || 'Add to cart failed');
  }

  const data = await response.json();
  
  // Publish cart update event
  if (typeof publish === 'function') {
    publish('cart:updated', data);
  }
  
  return data;
}

async function updateCartItem(line, quantity) {
  const body = JSON.stringify({
    line,
    quantity,
    sections: ['cart-drawer', 'cart-icon-bubble'],
    sections_url: window.location.pathname
  });

  const response = await fetch(CART_ROUTES.change, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body
  });

  if (!response.ok) throw new Error('Update cart failed');

  const data = await response.json();
  
  if (typeof publish === 'function') {
    publish('cart:updated', data);
  }

  return data;
}

window.SurpravCart = {
  fetch: fetchCart,
  add: addToCart,
  update: updateCartItem
};
